import "@/App.css";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useLenis();
  return (
    <div className="grain min-h-screen bg-background text-foreground">
      <Toaster theme="dark" position="top-center" richColors />
      <Nav />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Manifesto />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
